module.exports = __webpack_public_path__ + "img/304.1993547b.jpg";